import { render } from "./StepQuestions5645645.vue?vue&type=template&id=29bb31e1"
import script from "./StepQuestions5645645.vue?vue&type=script&lang=js"
export * from "./StepQuestions5645645.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__